import styled from 'styled-components'

export const BottomTabContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	width: 100%;
`

export const BottomTabSection = styled.div<{ isDarkMode?: boolean }>`
	width: 100%;
	height: 56px;
	z-index: 90005;
	position: fixed;
	display: flex;
	flex-direction: row;
	flex: 1;
	align-items: center;
	justify-content: space-around;
	bottom: 0;
	left: 0;
	right: 0;
	background: ${p => !p.isDarkMode
		? 'linear-gradient(to top, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.92) 100%)'
		: 'linear-gradient(to top, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)'
	};
	border-top: 2px solid ${p => !p.isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'};
	box-shadow: 0 -4px 12px ${p => !p.isDarkMode ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.08)'};
	backdrop-filter: blur(20px);
	padding: 0 8px;
`

export const ButtonTabItems = styled.button<{ isActive?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	border: none;
	outline: 0;
	cursor: pointer;
	padding: 6px 10px;
	gap: 3px;
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	flex: 1;
	max-width: 80px;

	&:active {
		transform: scale(0.95);
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 28px;
		height: 2px;
		border-radius: 0 0 2px 2px;
		background: ${p => p.theme.COLORS.point};
		opacity: ${p => p.isActive ? 1 : 0};
		transition: opacity 0.25s ease;
	}
`

export const TabIcon = styled.div<{ isActive?: boolean }>`
	font-size: 18px;
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	filter: ${p => p.isActive ? 'none' : 'grayscale(100%) opacity(0.5)'};
	transform: ${p => p.isActive ? 'scale(1.05)' : 'scale(1)'};
`

export const TabLabel = styled.span<{ isActive?: boolean }>`
	font-size: 11px;
	font-weight: ${p => p.isActive ? '600' : '500'};
	color: ${p => p.isActive ? p.theme.COLORS.point : p.theme.COLORS.textw};
	opacity: ${p => p.isActive ? 1 : 0.6};
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	white-space: nowrap;
`
